import gql from 'graphql-tag';

const getAddonsByTypeQuery = gql`
query getAddonsByType {
  getAddonsByType {
    ADDITIONAL_OUTPUT {
      costs
    }
    BURN_IN_CAPTIONS {
      costs
    }
    SRT_CAPTIONS {
      costs
    }
    LONGFORM_SHORT {
      costs
    }
    CHROMA_KEY {
      costs
    }
    EXTRA_FOOTAGE {
      costs
    }
    RUSH_EDIT {
      costs
    }
    SUPER_RUSH_EDIT {
      costs
    }
    LONGFORM_MEDIUM {
      costs
    }
    LONGFORM_LONG {
      costs
    }
    VOICE_OVER_ARTIST {
      costs
    }
    VOICE_OVER_ARTISTS_1MIN {
      costs
    }
    VOICE_OVER_ARTISTS_2MIN {
      costs
    }
    VOICE_OVER_ARTISTS_5MIN {
      costs
    }
    SUPERSIZE_MY_EDIT {
      costs
    }
  }
}
`;

const getAddonsByType = () => ({
  query: getAddonsByTypeQuery,
  module: 'finance',
  ignoreCache: true,
  buildVariables: () => {}
});

export default getAddonsByType;